import { useCallback } from 'react';
import { useReduxForm } from '@rainbow-modules/hooks';
import { CheckboxGroupProps } from 'react-rainbow-components/components/CheckboxGroup';
import CheckBoxGroupFilter, { CheckBoxGroupFilterLabel } from 'components/CheckBoxGroupFilter';

interface Params extends Omit<CheckboxGroupProps, 'value' | 'onChange'> {
    value?: string[] | null;
    onChange?: (values: string[] | null) => void;
}

const answeredByOptions = [
    {
        name: 'unknown',
        label: 'Unknown',
    },
    {
        name: 'human',
        label: 'Human',
    },
    {
        name: 'machine',
        label: 'Machine',
    },
];

const CallAnsweredBySelect = (props: Params) => {
    const {
        value: valueInProps,
        onChange = () => {},
        ...rest
    } = useReduxForm(props);

    const options = answeredByOptions.map(
        (option) => ({
            value: option.name,
            label: <CheckBoxGroupFilterLabel>{option.label}</CheckBoxGroupFilterLabel>,
        }),
    );

    const value = valueInProps ?? [];

    const handleOnChange = useCallback(
        (values: string[]) => {
            if (!values?.length || values.length === answeredByOptions.length) {
                return onChange(null);
            }
            return onChange(values);
        },
        [onChange],
    );

    return (
        <CheckBoxGroupFilter
            {...rest}
            hideLabel
            options={options}
            value={value}
            onChange={handleOnChange}
        />
    );
};

export default CallAnsweredBySelect;
